

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setHeaderName, setSubHeaderName } from '../../../ReduxStore/Slices/headerSlice';
import { Backdrop, Box, Button, Grid, Typography } from '@mui/material';
import CustomInputLogin from '../../../Components/CustomInputLogin/CustomInputLogin';
import { Formik, Form } from 'formik';
import CustomExcelUpload from '../../../Components/CustomExcelUpload/CustomExcelUpload';
import { BackHandSharp, Upload } from '@mui/icons-material';
import { IoIosArrowRoundBack } from "react-icons/io";
import CustomTable from '../../../Components/Table/CustomTable';
import actions from '../../../ReduxStore/actions';
import CustomInputForm from '../../../Components/CustomInputLogin/CustomInputForm';
import { toast, ToastContainer } from 'react-toastify';
import * as Yup from 'yup';
// import { updateDepartmentAction } from '../../../../ReduxStore/Slices/CreateDepartment/updateDepartment';
import axios from 'axios';
import { adminUrl } from '../../../constants';
import InvalidRowsModal from '../../../Components/InvalidRowsModal/InvalidRowsModal';
import FullPageLoader from '../../../Components/FullPageLoader/FullPageLoader';
import CustomDropdownMui from '../../../Components/CustomDropDown/CustomDropdown';
import CustomRadioButton from '../../../Components/CustomRadioButton/CustomRadioButton';
import TestMailDialog from './TestMailDialog';


// import * as Yup from "yup";

const validationSchema = Yup.object().shape({
    name: Yup.string()
        .required("SMTP Configuration Name is required"),

    host: Yup.string()
        .required("SMTP Host is required")
        .matches(
            /^([a-zA-Z0-9]+\.)+[a-zA-Z]{2,}$/,
            "Enter a valid SMTP host (e.g., smtp.office365.com)"
        ),

    port: Yup.number()
        .typeError("Port must be a number")
        .required("SMTP Port is required")
        .min(1, "Port must be a positive number")
        .max(65535, "Port must be a valid port number (1-65535)"),

    secure: Yup.boolean()
        .required("Secure flag is required"),

    user: Yup.string()
        .email("Enter a valid email address")
        .required("Email address is required"),

    pass: Yup.string()
        .required("Password is required"),

    tls_reject_unauthorized: Yup.boolean()
        .required("TLS reject unauthorized setting is required"),

    tls_ciphers: Yup.string()
        .notRequired(), // optional field

    require_tls: Yup.boolean()
        .notRequired()
});
const validationSchema1 = Yup.object().shape({
    to: Yup.string()
        .email("Enter a valid to email address")
        .required("To email address is required"),




})



const MailSettings = () => {
    const dispatch = useDispatch();
    const [showExcelUpload, setShowExcelUpload] = useState(false); // State to toggle
    const [responseTableData, setResponseTableData] = useState([]); // State to toggle

    const tableHeadData = ["S.No", "Departments", "Actions"];
    const tableData = [
        { departmentId: "3", department: "ASSEMBLY SUPERVISOR" },
        { departmentId: "4", department: "ASSEMBLY SUPERVISOR" },
        { departmentId: "5", department: "ASSEMBLY SUPERVISOR" },
        { departmentId: "6", department: "ASSEMBLY SUPERVISOR" },

    ]


    useEffect(() => {
        dispatch(setHeaderName("Settings"));
        dispatch(setSubHeaderName("Mail settings"));
    }, [dispatch]);
    const [editData, setEditData] = useState()
    const { updateDepartment } = useSelector((state) => state?.updateDepartment);
    const { createDepartment } = useSelector((state) => state?.createDepartment);
    const { updateEmailConfig } = useSelector((state) => state?.updateEmailConfig);





    const [invalidRowsModalopen, setInvalidRowsModalOpen] = useState(false);
    const [invalidRwModalResponseData, setInvalidRwModalResponseData] = useState([]);

    const handleInvalidRowsModalOpen = () => {
        setInvalidRowsModalOpen(true)
    }
    const handleInvalidRowsModalClose = () => {
        setInvalidRowsModalOpen(false)
    }

    const [loading, setLoading] = useState(false);



    const handleSubmit = async (values, { resetForm }) => {
        console.log(values, "valuesssssss")
        setLoading(true)



        const data1 = {
            data: values,
            method: "post",
            apiName: `updateEmailConfig`
        };
        const responseData = await dispatch(actions.UPDATEEMAILCONFIG(data1));
        console.log(responseData, "responseData")
        if (responseData?.payload?.message === "Email configuration updated successfully.") {
            setLoading(false)
            toast.success("Email configuration updated successfully.")
        }

        else {
            setLoading(false)

            toast.error(responseData?.payload?.message)
        }


    }
    const [open, setOpen] = useState(false);
    const handleTestSubmit = async (values, { resetForm }) => {
        console.log(values, "valuesssssss")
        setLoading(true)



        const data1 = {
            data: values,
            method: "post",
            apiName: `testEmailConnection`
        };
        const responseData = await dispatch(actions.TESTEMAILCONNECTION(data1));
        console.log(responseData, "responseData")
        if (responseData?.payload?.message === "Email configuration works. Test email sent successfully.") {
            setLoading(false)
            resetForm()
            // toast.success("Email configuration updated successfully.")
            setOpen(true)
        }

        else {
            setLoading(false)

            toast.error(responseData?.payload?.message)
        }


    }

    // const handleSamplDownload = () => {

    //     window.open(`${adminUrl}downloadDepartmentsSampleExcelFile`);
    // }
    const [rowTableData, setRowTableData] = useState([])
    console.log(rowTableData, "rowTableTAdatatattattat")


    const { getEmailConfig } = useSelector((state) => state?.getEmailConfig);
    console.log(getEmailConfig?.data?.secure, "getemailcocondfihg")


    useEffect(() => {
        const fetchData = async () => {

            const data1 = {
                data: {},
                method: "get",
                apiName: "getEmailConfig"
            };
            const responseData = dispatch(actions.GETEMAILCONFIG(data1));
            console.log(responseData, "responseData")


        }
        fetchData()

    }, [dispatch, updateEmailConfig])





    const { getDepartmentById } = useSelector((state) => state?.getDepartmentById);


    const handleTableEdit = async (id) => {
        setShowExcelUpload(false)
        setLoading(true)
        window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to top


        console.log(id, "idgretoriut")
        const data1 = {
            data: {},
            method: "get",
            apiName: `getDepartmentById/${id}`
        };
        const responseData = await dispatch(actions.GETDEPARTMENTDBYID(data1));
        console.log(responseData, "getDepartmentById")
        if (responseData?.payload?.message === "All Department fetched successfully.") {
            setLoading(false)
            setEditData(responseData?.payload?.data)
        }


    }



    const serviceMailOptions = [
        { value: "g suite", label: "G suite" },
        { value: "gmail", label: "Gmail" },
        { value: "outlook", label: "Outlook" },

    ]



    return (
        <Box>
            {loading && <FullPageLoader />}
            <Box
                sx={{
                    background: "white",
                    p: 3
                }}
            >
                <Typography variant='subtitle2' sx={{ color: "black", fontSize: "18px", mb: 2 }}>
                    Mail Configuration
                </Typography>

                <Formik
                    enableReinitialize
                    initialValues={{
                        name: getEmailConfig?.data?.name || "",
                        host: getEmailConfig?.data?.host || "",
                        port: getEmailConfig?.data?.port || "",
                        secure: getEmailConfig?.data?.secure ?? true,
                        // service: "",
                        user: getEmailConfig?.data?.user || "",
                        pass: getEmailConfig?.data?.pass || "",
                        tls_reject_unauthorized: getEmailConfig?.data?.tls_reject_unauthorized ?? true,
                        tls_ciphers: getEmailConfig?.data?.tls_ciphers || "",
                        require_tls: getEmailConfig?.data?.require_tls ?? true,
                    }}
                    validationSchema={validationSchema}

                    onSubmit={handleSubmit}
                >
                    {({ errors, touched, handleChange, values, setFieldValue, resetForm, isSubmitting }) => (
                        <Form>
                            <Grid container spacing={2} columnSpacing={4} mt={2}>
                                <Grid item size={{ xs: 12, md: 6 }}>

                                    <CustomInputForm
                                        name="name"
                                        label="SMTP Configuration Name"
                                        custPlaceholder="Ex.Outlook SMTP "
                                        options={serviceMailOptions}
                                        important={true}
                                    />
                                </Grid>
                                <Grid item size={{ xs: 12, md: 6 }}>

                                    <CustomInputForm
                                        name="host"
                                        label="SMTP Host"
                                        // inputType="number"
                                        custPlaceholder="Ex.smtp.office365.com"
                                        important={true}

                                    />

                                </Grid>

                                <Grid item size={{ xs: 12, md: 6 }}>

                                    <CustomInputForm
                                        name="port"
                                        label="SMTP Port"
                                        inputType="number"
                                        custPlaceholder="Ex.587"
                                        important={true}

                                    />

                                </Grid>
                                <Grid item size={{ xs: 12, md: 6 }}>

                                    <CustomRadioButton
                                        name="secure"
                                        label="Use Secure Connection (SSL/TLS)"
                                        // custPlaceholder="--Select--"
                                        value={values?.secure}
                                        onChange={(val) => setFieldValue("secure", val)}
                                        important={true}


                                        options={[
                                            { label: "True", value: true },
                                            { label: "False", value: false },

                                        ]}
                                    />
                                </Grid>
                                {/* <Grid item size={{ xs: 12, md: 6 }}>

                                    <CustomInputForm
                                        name="service"
                                        label="Email Service Provider"
                                        custPlaceholder="Ex.gmail"
                                        
                                    />

                                </Grid> */}
                                <Grid item size={{ xs: 12, md: 6 }}>

                                    <CustomInputForm
                                        name="user"
                                        label="Email Address / SMTP Username"
                                        custPlaceholder="Ex.yourname@example.com"
                                        important={true}

                                    />

                                </Grid>
                                <Grid item size={{ xs: 12, md: 6 }}>

                                    <CustomInputForm
                                        name="pass"
                                        label="Email Password"
                                        custPlaceholder="Enter Password"
                                        important={true}

                                    />

                                </Grid>
                                <Grid item size={{ xs: 12, md: 6 }}>

                                    <CustomRadioButton
                                        name="tls_reject_unauthorized"
                                        label="TLS - Reject Unauthorized Certificates"
                                        // custPlaceholder="--Select--"
                                        value={values?.tls_reject_unauthorized}
                                        onChange={(val) => setFieldValue("tls_reject_unauthorized", val)}

                                        options={[
                                            { label: "True", value: true },
                                            { label: "False", value: false },

                                        ]}
                                        important={true}

                                    />
                                </Grid>
                                <Grid item size={{ xs: 12, md: 6 }}>

                                    <CustomInputForm
                                        name="tls_ciphers"
                                        label="TLS Cipher Suite(Optional)"
                                        custPlaceholder="Ex.SSLv3"
                                    />

                                </Grid>

                                <Grid item size={{ xs: 12, md: 6 }}>

                                    <CustomRadioButton
                                        name="require_tls"
                                        label="Require TLS Encryption(optional)"
                                        // custPlaceholder="--Select--"
                                        value={values?.require_tls}
                                        onChange={(val) => setFieldValue("require_tls", val)}

                                        options={[
                                            { label: "True", value: true },
                                            { label: "False", value: false },

                                        ]}
                                    />
                                </Grid>




                                {/* {!showExcelUpload && ( */}
                                <Grid item size={{ xs: 12 }} sx={{ mt: 3 }}>
                                    <Button
                                        type="submit"
                                        variant='contained'
                                        disabled={isSubmitting}
                                        sx={{
                                            background: "var(--main-color)",
                                            textTransform: "none"
                                        }}
                                    >
                                        Submit
                                    </Button>
                                </Grid>
                                {/* )} */}
                            </Grid>
                        </Form>
                    )}
                </Formik>
            </Box>
            <Box
                sx={{
                    background: "white",
                    p: 3,
                    mt: 6
                }}
            >
                <Typography variant='subtitle2' sx={{ color: "black", fontSize: "18px", mb: 2 }}>
                    Test Configuration Mail
                </Typography>

                <Formik
                    enableReinitialize
                    initialValues={{
                        to: "",

                    }}
                    validationSchema={validationSchema1}

                    onSubmit={handleTestSubmit}
                >
                    {({ errors, touched, handleChange, values, setFieldValue, resetForm, isSubmitting }) => (
                        <Form>
                            <Grid container spacing={2} columnSpacing={4} mt={2}>
                                <Grid item size={{ xs: 12, md: 6 }}>

                                    <CustomInputForm
                                        name="to"
                                        label="To Mail"
                                        custPlaceholder="Ex.yourname@example.com"
                                        // options={serviceMailOptions}
                                        important={true}
                                    />
                                </Grid>
                                <Grid item size={{ xs: 12 }} sx={{ mt: 3 }}>
                                    <Button
                                        type="submit"
                                        variant='contained'
                                        disabled={isSubmitting}
                                        sx={{
                                            background: "var(--main-color)",
                                            textTransform: "none"
                                        }}
                                    >
                                        Submit
                                    </Button>
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>


            </Box>
            {/*
                <Grid container spacing={2}>
                    <Grid item size={{ xs: 12 }} sx={{ width: "100px", flex: 1 }}>
                        <CustomTable
                            tableHeadData={tableHeadData}
                            tableData={rowTableData}
                            title="Department List"
                            tableEdit={true}
                            tableActions={true}
                            tableSearch={true}
                            handleTableEdit={handleTableEdit}


                        />
                    </Grid>
                </Grid>
            </Box> */}
            <ToastContainer position="top-right" autoClose={1500} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="dark" />
            <InvalidRowsModal name="department" open={invalidRowsModalopen} onClose={handleInvalidRowsModalClose} data={invalidRwModalResponseData} />
            <TestMailDialog open={open} onClose={() => setOpen(false)} />

        </Box >
    );
};

export default MailSettings;
